import { KeepDataFromQuoteRoleDefinition } from '@/features/Sparten/types';
import {
  KEEP_DATA_FROM_QUOTE_MAPPING,
  keepDataFromQuoteMappings,
} from '@/features/Sparten/shared/keepDataFromQuoteMappings';

export const keepDataFromQuoteClientConfiguration: KeepDataFromQuoteRoleDefinition =
  {
    versicherungsnehmer: [
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.BANK_INFORMATION
      ],
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.FUEHRERSCHEINDATUM
      ],
    ],
    zahlPerson: [
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.BANK_INFORMATION
      ],
    ],
    fahrer1: [
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.FUEHRERSCHEINDATUM
      ],
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.KFZ_FAHRER_META
      ],
    ],
    fahrer2: [
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.FUEHRERSCHEINDATUM
      ],
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.KFZ_FAHRER_META
      ],
    ],
    fahrer3: [
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.FUEHRERSCHEINDATUM
      ],
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.KFZ_FAHRER_META
      ],
    ],
    fahrer4: [
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.FUEHRERSCHEINDATUM
      ],
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.KFZ_FAHRER_META
      ],
    ],
    fahrer5: [
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.FUEHRERSCHEINDATUM
      ],
      ...keepDataFromQuoteMappings[
        KEEP_DATA_FROM_QUOTE_MAPPING.KFZ_FAHRER_META
      ],
    ],
  };
